import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=07ce0dbd&scoped=true"
import script from "./GiftCard.vue?vue&type=script&lang=js"
export * from "./GiftCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ce0dbd",
  null
  
)

export default component.exports